export const endpoints = {
    pluginStatus:'plugin_active_status',
    getOrdersList:'wp-json/wc/v2/quivers/fetchorderstatus'
}